export default __webpack_public_path__ + "static/media/PlusIcon.1757757f.svg";